export default __webpack_public_path__ + "locales/it/ChangePasswordDialog.json?hash=07fe008636af21b81d3025a5e792f87e";